

import React from "react";

import {
  Swiper,
  SwiperSlide,
} from "swiper/react";

import {
  Autoplay,
  Pagination,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "./Testimonials.css";

const testimonials = [
  {
    text: "Booked Mumbai to Shirdi Cab with Shreesha Tours & Travels. The driver was punctual, the car was clean, and the complete journey was safe and comfortable.",
    name: "Mr. Rahul Sharma",
    rating: 5,
  },
  {
    text: "Excellent Mumbai Airport Taxi Service. The driver arrived before time and provided a smooth airport transfer experience. Highly recommended.",
    name: "Mrs. Priya Desai",
    rating: 5,
  },
  {
    text: "We hired an Innova Crysta for our family trip from Mumbai to Goa. The vehicle was spacious, well maintained, and the service was excellent.",
    name: "Mr. Amit Patil",
    rating: 4.5,
  },
  {
    text: "Shreesha Tours & Travels provides reliable outstation cab services. Professional drivers, comfortable cars, and affordable pricing.",
    name: "Miss. Sneha Kulkarni",
    rating: 5,
  },
  {
    text: "Our pilgrimage tour was perfectly arranged by Shreesha Travels. Comfortable journey with experienced drivers and great support.",
    name: "Mrs. Kavita Joshi",
    rating: 5,
  },
];

const Rating = ({ rating }) => {
  return (
    <div className="rating">
      {[1, 2, 3, 4, 5].map((item) => (
        <span key={item}>
          {rating >= item ? "★" : "☆"}
        </span>
      ))}
    </div>
  );
};

function Testimonials() {
  return (
    <section className="testimonial-section">
      <div className="container">

        <div className="testimonial-top">

          <div className="testimonial-image">
            <img
              src="/images/man-with-car.png"
              alt="Shreesha Travels"
            />
          </div>

          <div className="testimonial-content">

            <div className="testimonial-title">

              <div className="title-lines">
                <span></span>
                <span></span>
                <span></span>
              </div>

              <h2>
                Customer Testimonials & Reviews
              </h2>

            </div>

            <p>
              Don't just take our word for it. Read what thousands of
              satisfied customers say about their experience with
              Shreesha Tours & Travels for airport transfers,
              outstation cabs, corporate travel, pilgrimage tours
              and family trips.
            </p>

            <div className="review-users">

              <div className="users">
                <img src="/images/users/user1.jpg" alt="Customer" />
                <img src="/images/users/user2.jpg" alt="Customer" />
                <img src="/images/users/user3.jpg" alt="Customer" />

                <div className="more-users">+</div>
              </div>

              <div>
                <Rating rating={5} />

                <span>5000+ reviews</span>

                <p>
                  Trusted by happy travelers across India
                </p>
              </div>

            </div>

          </div>

        </div>

        {/* TESTIMONIAL SLIDER */}

        <div className="testimonial-slider">

          <Swiper
            modules={[Autoplay, Pagination]}

            spaceBetween={25}

            slidesPerView={3}

            slidesPerGroup={1}

            loop={true}

            speed={800}

            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}

            pagination={{
              clickable: true,
            }}

            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 15,
              },

              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },

              1024: {
                slidesPerView: 3,
                spaceBetween: 25,
              },
            }}

            className="testimonial-swiper"
          >

            {testimonials.map((item, index) => (

              <SwiperSlide key={index}>

                <div className="testimonial-card">

                  <Rating rating={item.rating} />

                  <p>
                    {item.text}
                  </p>

                  <h4>
                    {item.name}
                  </h4>

                </div>

              </SwiperSlide>

            ))}

          </Swiper>

        </div>

      </div>
    </section>
  );
}

export default Testimonials;